import {de_DE_formal} from '@App/locales/de_DE-formal';
import {de_DE_globalTranslations} from "@App/locales/de_DE-globalTranslations";

export const meinauto = {
    ...de_DE_formal,
    ...{
        translation: {
            ...de_DE_globalTranslations.translation,
            layout: {
                backText: 'Zurück zu meinauto.de'
            },
            linkToHome: 'https://werkstatt.repareo.de/partner/meinauto',
            tireStepText: {
                tiresAlreadyStored: 'meineReifen'
            },
            booking: {
                'headline': 'Termin buchen',
                'subheadline': 'Service: {{service}}',
                'slot-taken-1': 'Schade! Da war leider jemand schneller und hat Ihren Wunschtermin am',
                'slot-taken-2': 'reserviert. Bitte wählen Sie einen anderen Termin.',
                'no-slots': 'Aktuell sind in dieser Werkstatt keine Termine für den gewählten Zeitraum verfügbar.',
                'error-nearest-slot-gone': 'Puh, die Werkstatt hat einiges zu tun: Der {{ day }} ist jetzt schon ausgebucht. Ab dem {{ newDay }} sind wieder Termine frei.',
                'next-free-slot': 'Nächster freier Termin:',
                'chosen-slot': 'Ausgewählter Termin:',
                'please-choose-services': 'Bitte wählen Sie die gewünschten Services',
                'more-information-link': 'Mehr zum Terminablauf',
                'hint': `Die finale Terminbestätigung erfolgt durch die Prüfstelle.<br/> Bitte beachten Sie: Eine Rückgabe vor Ihrem Vertragsende kann zusätzliche Kosten verursachen (z. B. Verfall von Minderkilometern).`,
                'blocking': 'Termin wird reserviert...',
                'submit': 'Termin sichern',
                moreInformation: {
                    'headline': 'Wie genau läuft der Termin ab?',
                    'bullet-point-1': 'Ihre Buchung geht direkt in den Kalender der {{garageType}}.',
                    'bullet-point-2': 'Bitte geben Sie Ihr Auto zu Beginn des Termins ab.',
                    'bullet-point-3': 'Die {{garageType}} informiert Sie telefonisch, sobald Sie Ihr Auto abholen können.',
                    'bullet-point-4': 'Sie können ihren Termin jederzeit kostenfrei absagen.',
                    'bullet-point-5': '',
                    'bullet-point-6': '',
                    'instant-booking': 'Diese Werkstatt erhält Ihren gebuchten Termin direkt in den Kalender. Somit ist der Termin sofort bestätigt.',
                    'request-booking': 'Diese Werkstatt erhält eine Terminanfrage und bestätigt Ihren Wunschtermin so schnell wie möglich.'
                },
                vehicleReturn: {
                    'headline': 'Termine',
                    'submit': 'Termin auswählen',
                }
            },
        },
    }
}
